module.exports = __webpack_public_path__ + "img/newlogo2.3e243b7c.png";